export default "__VITE_ASSET__y6Jp7m$$__"